/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Resend_Invitation_ConfirmInputs */

const en_users_resend_invitation_confirm = /** @type {(inputs: Users_Resend_Invitation_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend invitation`)
};

const pt_br2_users_resend_invitation_confirm = /** @type {(inputs: Users_Resend_Invitation_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar convite`)
};

/**
* | output |
* | --- |
* | "Resend invitation" |
*
* @param {Users_Resend_Invitation_ConfirmInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_resend_invitation_confirm = /** @type {((inputs?: Users_Resend_Invitation_ConfirmInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Resend_Invitation_ConfirmInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_resend_invitation_confirm(inputs)
	return pt_br2_users_resend_invitation_confirm(inputs)
});